// Lib
import React, { useEffect } from 'react';
import { useDragLayer } from 'react-dnd';

// Components
import ElementDragLayer from './elementDragLayer/ElementDragLayer';
import ErrorBoundary from '../../components/error/errorBoundary/ErrorBoundary';
import DragLayerErrorRenderer from './DragLayerErrorRenderer';

// Utils
import { prepareElementsForDrag } from './elementDragUtils';

// Constants
import { ELEMENT_DND_TYPE } from '../../../common/elements/elementConstants';

// Styles
import './WorkspaceDragLayer.scss';

type WorkspaceDragLayerProps = {
    currentBoardId: string;
    permissions: number;
    setIsDragging: Function;
};

const WorkspaceDragLayer = ({ setIsDragging, currentBoardId, permissions }: WorkspaceDragLayerProps) => {
    const { isDragging, itemType, item } = useDragLayer((monitor) => ({
        isDragging: monitor.isDragging(),
        itemType: monitor.getItemType(),
        item: monitor.getItem(),
    }));

    useEffect(() => {
        setIsDragging(isDragging, itemType);

        if (!isDragging) return () => {};

        const clear = prepareElementsForDrag(item);
        return clear;
    }, [isDragging]);

    if (!isDragging || itemType !== ELEMENT_DND_TYPE) return null;

    return (
        <div className="WorkspaceDragLayer">
            <ErrorBoundary ErrorRenderer={DragLayerErrorRenderer}>
                <ElementDragLayer currentBoardId={currentBoardId} permissions={permissions} />
            </ErrorBoundary>
        </div>
    );
};

export default WorkspaceDragLayer;
